import { render, staticRenderFns } from "./rfq-add-or-update.vue?vue&type=template&id=735bba46"
import script from "./rfq-add-or-update.vue?vue&type=script&lang=js"
export * from "./rfq-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./rfq-add-or-update.vue?vue&type=style&index=0&id=735bba46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports